import React from "react"

import { PRODUCT_POSITION_TABLE_KEY_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowVariantKeyCellProps
  extends ProductPositionRowCellProps {
  variantKey: string
}

export const ProductPositionRowVariantKeyCell = React.memo(
  React.forwardRef(
    (
      { variantKey, ...rest }: ProductPositionRowVariantKeyCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => (
      <ProductPositionTableCell
        ref={ref}
        aria-labelledby={PRODUCT_POSITION_TABLE_KEY_HEADER_ID}
        className="key"
        data-testid="variant-key-cell"
        title={variantKey}
        {...rest}
      >
        <div className="table-row-cell__content">{variantKey}</div>
      </ProductPositionTableCell>
    )
  )
)
